/**
 * Add pager with index, add element with class `splide__page-index`
 *
 */
export function SlideNumber(Splide, Components) {
    const { track } = Components.Elements

    let pageIndex

    function mount() {
        pageIndex = Splide.root.querySelector('.splide__page-index')

        if (pageIndex === null) {
            return false
        }

        update()
        Splide.on('move', update)
    }

    function update() {
        pageIndex.textContent = `${Splide.index + 1} / ${Splide.length}`
    }

    return {
        mount
    }
}